(function(angular, _) {
    /**
     * @ngdoc component
     * @name GridTableModalController
     * @description Controller for the grid table settings modal
     */
    class GridTableModalController {
        static get $inject() {
            return ['$modalInstance', 'columns'];
        }

        constructor($modalInstance, columns) {
            this.$modalInstance = $modalInstance;

            this.columns = _.concat([], columns);
            this.configurableColumns = _.filter(this.columns, this.isConfigurableColumn.bind(this));
            this.columnsVisibilityModel = {};
            _.forEach(this.configurableColumns, (col) => {
                this.columnsVisibilityModel[col.key] = col.visible;
            });
        }

        isConfigurableColumn(column) {
            return _.isBoolean(column.configurable) ? column.configurable : (
                _.has(column.configurable, 'visible')
            );
        }

        /**
         * @ngdoc method
         * @name GridTableModalController#canChangeColumnVisibility
         * @description Checks if changing visibility of a column is allowed by its configuration
         * @param {Object} column The column configuration
         * @returns {boolean}
         */
        canChangeColumnVisibility(column) {
            return _.isPlainObject(column.configurable)
                ? _.get(column.configurable, 'visible', true)
                : column.configurable;
        }

        /**
         * @ngdoc method
         * @name GridTableModalController#getResultColumns
         * @description Joins the configurable and non-configurable columns into a result set, respecting the order of the configurable columns
         * at the same time restoring the non-configurable columns position in the resulting array.
         * @returns {Array}
         */
        getResultColumns() {
            const resultColumns = _.concat([], this.configurableColumns);

            _.forEach(this.columns, (column, index) => {
                column.visible = _.get(this.columnsVisibilityModel, column.key);
                const configurable = this.isConfigurableColumn(column);

                if (!configurable) {
                    let position;

                    switch (_.get(column.configurable, 'position')) {
                        case 'first':
                            position = 0;
                            break;
                        case 'last':
                            position = _.size(this.columns) - 1;
                            break;
                        default:
                            position = _.get(column.configurable, 'position', index);
                    }

                    resultColumns.splice(position, 0, column);
                }
            });

            return resultColumns;
        }

        /**
         * @ngdoc method
         * @name GridTableModalController#cancelChanges
         * @description Dismisses the settings screen and cancels any configuration done
         * @returns {*}
         */
        cancelChanges() {
            return this.$modalInstance.dismiss('cancel');
        }

        /**
         * @ngdoc method
         * @name GridTableModalController#applyChanges
         * @description Applies the configurations done in the settings screen
         * @returns {*}
         */
        applyChanges() {
            const columns = this.getResultColumns();

            return this.$modalInstance.close(columns);
        }
    }

    angular.module('wtUi.wtGridTable').controller('GridTableModalController', GridTableModalController);
})(window.angular, window._);
